import { __assign } from "tslib";
import React from 'react';
var NativeOption = React.forwardRef(function (props, ref) {
    return React.createElement("option", __assign({ ref: ref }, props));
});
NativeOption.displayName = 'NativeOption';
export default NativeOption;
//# sourceMappingURL=native-option.js.map